import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Modal, Button } from 'react-bootstrap'
import CustomModal from '../../../CustomModal/CustomModal'
import { updateSpaceAsync } from '../../../../Manage/actions'
import styles from './EditSpaceModal.module.css'

const EditSpaceModal = ({ isOpen, spaceId, spaceName, onClose }) => {
  const dispatch = useDispatch()
  const [newName, setNewName] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (isOpen && spaceName) {
      setNewName(spaceName)
      setError('')
    }
  }, [isOpen, spaceName])

  const handleSave = async () => {
    const trimmedName = newName.trim()

    if (!trimmedName) {
      setError('Space name cannot be empty')
      return
    }

    if (trimmedName.length > 25) {
      setError('Space name cannot exceed 25 characters')
      return
    }

    if (trimmedName === spaceName) {
      onClose()
      return
    }

    setIsLoading(true)
    setError('')

    try {
      await dispatch(updateSpaceAsync(spaceId, { name: trimmedName }))
      onClose()
    } catch (error) {
      setError('Failed to rename space. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave()
    } else if (e.key === 'Escape') {
      onClose()
    }
  }

  const handleClose = () => {
    if (!isLoading) {
      onClose()
    }
  }

  return (
    <CustomModal show={isOpen} onHide={handleClose} centered size="md" enforceFocus={false} className={styles.modal}>
      <div className="p-4">
        <Modal.Header closeButton className={styles.header}>
          <Modal.Title className={styles.title}>Rename space</Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.body}>
          <div className={styles.inputGroup}>
            <input
              type="text"
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              onKeyDown={handleKeyDown}
              className={styles.input}
              placeholder="Space name"
              maxLength={25}
              autoFocus
              disabled={isLoading}
            />
            {error && <div className={styles.error}>{error}</div>}
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.footer}>
          <Button variant="outline-secondary" onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={isLoading || !newName.trim() || newName.trim() === spaceName}
            className={styles.saveButton}
          >
            {isLoading ? 'Saving...' : 'Save'}
          </Button>
        </Modal.Footer>
      </div>
    </CustomModal>
  )
}

export default EditSpaceModal
